import { render, staticRenderFns } from "./performanceUnitSnapshotComponent.vue?vue&type=template&id=dcd7f5cc&scoped=true&"
import script from "./performanceUnitSnapshotComponent.vue?vue&type=script&lang=js&"
export * from "./performanceUnitSnapshotComponent.vue?vue&type=script&lang=js&"
import style0 from "./performanceUnitSnapshotComponent.vue?vue&type=style&index=0&id=dcd7f5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd7f5cc",
  null
  
)

export default component.exports